 <template>
  <div>
    <v-container fluid pa-0 v-show="showComponent">
      <div class="banner-wrap">
        <Banner class="pc-banner " :is-hitech="false" />
      </div>
      <TopBoardCategories
        :header="articlesByCategory.name"
        :subHeader="articlesByCategory.title"
        :showSearch="false"
        :class="'articles-category'"
      />
    </v-container>

    <v-container fluid px-3 px-sd-0 px-md-0 v-show="showComponent">
      <div class="section_inner">
        <ArticleBreadcrumbs :items="breadCrumbs" class="pr-0 pr-md-3" />
        <v-row>
          <!-- ArticlesOfTheWeek -->
          <v-col cols="12" sm="12" md="9">
            <v-row>
              <v-col cols="12" v-if="articleOfTheWeekMentors || lectureOfTheWeekMentors">
                <h3 class="primary--text">כתבות השבוע</h3>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                    v-if="articleOfTheWeekMentors"
                  >
                    <ArticleTip
                      :item="articleOfTheWeekMentors"
                      :height="'290px'"
                      :darkMode="true"
                      :highlight="'כתבת השבוע'"
                      :isVideo="false"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                    v-if="lectureOfTheWeekMentors"
                  >
                    <ArticleTip

                      :item="lectureOfTheWeekMentors"
                      :height="'290px'"
                      :darkMode="true"
                      :highlight="'הרצאת השבוע'"
                      :isVideo="false"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <!-- WebinarsArticles -->

              <v-col cols="12" v-if="lectures && lectures.length > 0">
                <h3 class="primary--text">הרצאות</h3>
                <v-layout align-start column class="hidden-sm-and-down">
                  <v-container pa-0>
                    <v-layout align-start wrap>
                      <v-flex
                        v-for="(tip, index) in lectures"
                        :key="index"
                        sm4
                        xs12
                      >
                        <ArticleTip :item="tip" :breakFooter="true" />
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-layout>
                <v-container pa-0>
                  <v-layout align-start wrap>
                    <v-flex
                      v-for="(tip, index) in lectures"
                      :key="index"
                      class="guide-tip-item"
                      column
                      d-flex
                      xs12
                    >
                      <GuideTip :item="tip" :class="{'border-m': (parseInt(index)+1)%2==0 }" class="hidden-md-and-up mb-12 mt-n10" />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-col>
              <v-col cols="12">
                <h3 class="primary--text">כתבות</h3>
                <CategoryArticles
                  class="hidden-sm-and-down"
                  :showCategoryTitle="false"
                  :items="[articlesByCategory]"
                  :breakFooter="true"
                />
                <ArticleGuideTips
                  class="hidden-md-and-up mb-12 mt-n10"
                  :showCategoryTitle="false"
                  :items="[articlesByCategory]"
                />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="3" class="pt-6 hidden-sm-and-down">
            <LeftPanel />
          </v-col>
        </v-row>
        <VideoModal />
      </div>
    </v-container>
  </div>
</template>




<script>
import { isNil } from 'lodash';

import Banner from '@/components/Jobs_List/Banner';
import TopBoardCategories from '@/components/CategoriesPage/TopBoardCategories';
import CategoryArticles from '~/components/Articles/CategoryArticles';
import ArticleGuideTips from '~/components/Articles/ArticleGuideTips';

import LeftPanel from '@/components/LeftPanel';
import SeoOptimization from '@/components/mixins/SeoOptimization';
import DeviceDetect from '@/components/mixins/DeviceDetect';
import {
  ARTICLES_CATEGORIES,
  ARTICLES_CATEGORIES_SEO,
  axiomLog
} from '@/lib/api.js';
import VideoModal from '@/components/VideoModal';
import ArticleTip from '@/components/Articles/ArticleTip';
import GuideTip from '@/components/Articles/GuideTip';

export default {
  name: 'articlesPage',
  mixins: [SeoOptimization, DeviceDetect],
  components: {
    Banner,
    TopBoardCategories,
    LeftPanel,
    CategoryArticles,
    ArticleGuideTips,
    VideoModal,
    ArticleTip,
    GuideTip
  },

  data() {
    return {
      showComponent: false,
      articlesByCategory: {},
      articlesOfTheWeek: {},
      articleOfTheWeekMentors: {},
      lectureOfTheWeekMentors: {},
      lectures: [],
      breadCrumbs: []
    };
  },
  async asyncData({ error, route, $axios, $sentry, req }) {
    const categoryString = route.params.cat;

    //remove "cat" prefix to get the category code
    const categoryCode = !isNil(categoryString)
      ? parseInt(categoryString.substr(3, categoryString.length))
      : 0;

    if (categoryCode < 1) {
      throw 'שגיאת מערכת ';
    }

    const articlesByCategoryReq = `${ARTICLES_CATEGORIES}${categoryCode}`;
    const articlesByCategorySeoReq = `${ARTICLES_CATEGORIES_SEO}${categoryCode}`;

    try {
      const {
        data: { data: data }
      } = await $axios.get(articlesByCategoryReq);
      const {
        data: { data: seo }
      } = await $axios.get(articlesByCategorySeoReq);

      await axiomLog($axios, route.path, req, error);

      if (data.IsError) {
        throw 'שגיאת מערכת ';
      }

      return {
        showComponent: true,
        articlesByCategory: data.articlesByCategory,
        articleOfTheWeekMentors: data.articleOfTheWeekMentors,
        lectureOfTheWeekMentors: data.lectureOfTheWeekMentors,
        lectures: data.lectures,
        breadCrumbs: [
          {
            name: 'Home page',
            value: 'דרושים',
            link: '/'
          },
          {
            name: 'lobby',
            value: 'מגזין קריירה',
            link: '/articles/'
          },
          {
            name: 'category',
            value: data.articlesByCategory.name,
            link: `/articles/cat${data.articlesByCategory.id}`
          }
        ],
        seodata: {
          metaData: seo.metaDataItems,
          pageTitle: seo.title,
          breadCrumbsSchema: {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Home page',
                item: 'https://www.drushim.co.il/'
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: 'Articles lobby',
                item: 'https://www.drushim.co.il/articles/'
              },
              {
                '@type': 'ListItem',
                position: 3,
                name: data.articlesByCategory.name
              }
            ]
          }
        }
      };
    } catch (e) {
      $sentry.captureException('articles by category error: ' + e);
      await axiomLog($axios, route.path, req, e);
    }
  },
  mounted() {
    // run scroll to top after timeout for better performance (avoid reflow)
    window.scrollTo(0, 0);
  },
  head() {
    return {
      link: [
        {
          //canonical doesnt returned from api
          rel: 'canonical',
          href: 'https://www.drushim.co.il' + this.$route.fullPath
        }
      ],
      title: this.seodata.pageTitle,
      meta: this.seodata.metaData,
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          innerHTML: JSON.stringify(this.seodata.breadCrumbsSchema),
          type: 'application/ld+json'
        }
      ]
    };
  }
};
</script>


<style scoped>
html {
  scroll-behavior: unset;
}
</style>
